export const arrayBufferToBlob = (data: ArrayBuffer, type: string): Blob => {
    return new Blob([data], { type });;
};
